import type { IconSvgObject } from './types';

const MinusSignIcon: IconSvgObject = [
  ["path", { d: "M20 12L4 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default MinusSignIcon;
